import { isDateValid } from './isDateValid';

export const isDateInvalid = (value: Date) => !isDateValid(value);
